/**
 * The types of data that can be retrieved and subscribed to from the WebApi.
 */
export enum SubscriptionTypes {
    Camera,
    Dms,
    DispatchLogCallType,
    DispatchLogEntry,
    DispatchLogOrganization,
    DispatchLogType,
    ShortEventStatus,
    Station,
    District,
    Permissions,
    Region,
    DetectorConfig,
    DetectorMap,
    LinkGeometry,
    LinkData,
    LinkPollData,
    LinkPollStatus,
    Node,
    Jwt,
    QueueStatusWrapper
}